// src/config.ts
const production = process.env.REACT_APP_PRODUCTION == "true";
const domain = `centralpremiada.com.br`;

export const config = {
  // --- Connection Configs --- //
  production,
  apiUrl: production
    ? `https://api.${domain}`
    : "http://localhost:3333",

  domain,
  
  // --- URL's Configs --- //
  urls: {
    store: `https://${domain}`,
    panel: `https://painel.${domain}`, // Customer's Panel

    linkedIn: `https://www.linkedin.com/in/adriano-ferreira-020880118/`,
    instagram: `https://www.instagram.com/adriano.swatt/`,
    facebook: `https://www.facebook.com/adriano.swatt.3/`,
    youtube: `https://www.youtube.com/`,
  },
  
  // --- System Configs --- //
  appName: `Central Premiada`,
  appAgent: `rafflecentral`,

  // --- Made By --- //
  made: {
    company: {
      name: "iSwatt Corp®",
      website: `https://${domain}`,
    },
  },

  // --- Examples --- //
  examples: {
    email: `contato@${domain}`,
  },
};
